import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { RatingSelectorComponent } from './rating-selector.component';
import { MainPipe } from '../../../shared/pipes/pipes.module';

@NgModule({
  declarations: [RatingSelectorComponent],
  exports: [RatingSelectorComponent],
  imports: [CommonModule, MatButtonModule, MatIconModule, MainPipe],
})
export class RatingSelectorModule {}
